/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

/**
 * Valid reaction types for allergies.
 */
export type ReactionTypeT = (typeof ReactionTypeT)[keyof typeof ReactionTypeT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReactionTypeT = {
  Allergy: "Allergy",
  AdverseReaction: "AdverseReaction",
} as const;
